import {
  change_app_language,
  change_login,
  reset_state,
} from "redux/actions/AppActions";
import { set_is_logging_out } from "redux/actions/AuthActions";
import { setTokenExpired } from "redux/actions/TokenActions";
import { constants } from "redux/constants/redux-constants";
import { store } from "redux/store";
import { killIntervals } from "./common_helper";
import { recognizerManager } from "screens/patientInfo/classes/RecognizerManager";

export const handleLogout = () => {
  recognizerManager.stopTranscription();
  killIntervals()
  const state = store.getState();
  const language = state?.app?.language;
  store.dispatch(setTokenExpired(true));

  store.dispatch(change_login(constants?.USER_LOGOUT));
  store.dispatch(reset_state());
  store.dispatch(change_app_language(language || "en"));
};

export const TokenValidate = () => {
  const state = store.getState();
  store.dispatch(setTokenExpired(false));
};
